import styled from "styled-components";

export const Container = styled.div`
  color: #a3a3a3;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 90vh;
  object-fit: cover;
`;

export const ContentWrapper = styled.div`
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
  gap: 48px;

  @media (max-width: 768px) {
    flex-direction: column;
}
`;

export const InfoSidebar = styled.div`
  flex: 4;
  position: sticky;
  top: 48px;
  height: fit-content;

  h2 {
    margin-bottom: 4px;
    font-weight: bold;
  }

  h6 {
    margin-bottom: 6px;
  }

  p {
    margin-bottom: 16px;
    margin-top: 24px;
    font-size: 0.95rem;
    color: #555;
    text-align: justify;
  }
  
  @media (max-width: 768px) {
    position: static;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    padding: 20px 0;
  }
`;

export const ProjectContent = styled.div`
  flex: 6;
  p {
    margin-bottom: 12px;
    line-height: 1.6;
    color: #444;
  }
`;

export const TitleSection = styled.div`
  margin-bottom: 40px;

  h2 {
    font-size: 3rem;
    margin-bottom: 10px;
  }

  p {
    font-size: 1.2rem;
    color: #666;
  }
`;

export const ImageBlock = styled.img`
  width: 100%;
  margin-bottom: 48px;
  object-fit: cover;
  border-radius: 2px;
`;

export const NavLinks = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 40px;
`;

export const NavLinkItem = styled.a`
  font-size: 0.95rem;
  color: #777;
  text-decoration: none;
  &:hover { color: #333; }
`;